import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {

  1: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P7-E1',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page7/E1/Key/answerKey.png',
    checkUppercase: true,
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page7/E1/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page7/E1/3.jpg', input: true, answer: "There is a" },
        { url: 'img/FriendsPlus/Page7/E1/4.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page7/E1/6.jpg', input: true, answer: "There are three" },
        { url: 'img/FriendsPlus/Page7/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page7/E1/8.jpg', input: true, answer: "There are two" },
        { url: 'img/FriendsPlus/Page7/E1/9.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page7/E1/11.jpg', input: true, answer: "There is a" },
        { url: 'img/FriendsPlus/Page7/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page7/E1/13.jpg', input: true, answer: "There are ten" },
        { url: 'img/FriendsPlus/Page7/E1/14.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P7-E2',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page7/E2/Key/answerKey.png',
    component: D1,
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page7/E2/1.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/3.jpg', input: true, answer: "3" },
        { url: 'img/FriendsPlus/Page7/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/5.jpg', input: true, answer: "5" },
        { url: 'img/FriendsPlus/Page7/E2/6.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E2/7.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/9.jpg', input: true, answer: "two" },
        { url: 'img/FriendsPlus/Page7/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/11.jpg', input: true, answer: "four" },
        { url: 'img/FriendsPlus/Page7/E2/12.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E2/13.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/15.jpg', input: true, answer: "7" },
        { url: 'img/FriendsPlus/Page7/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/17.jpg', input: true, answer: "9" },
        { url: 'img/FriendsPlus/Page7/E2/18.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E2/19.jpg' },
      ],
      [
        { url: 'img/FriendsPlus/Page7/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/21.jpg', input: true, answer: "six" },
        { url: 'img/FriendsPlus/Page7/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/23.jpg', input: true, answer: "eight" },
        { url: 'img/FriendsPlus/Page7/E2/24.jpg' },
        { url: 'img/FriendsPlus/Page7/E2/25.jpg', input: true, answer: "ten" },
      ]
    ]
  },

  3: { // Exercise num
    unit: 'Starter',
    id: 'WB3-S-P7-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 2,
    exerciseKey: 'img/FriendsPlus/Page7/E3/Key/answerKey.png',
    titleImage: '',
    isAllowSubmit: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page7/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page7/E3/2.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page7/E3/3.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page7/E3/4.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page7/E3/5.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page7/E3/6.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page7/E3/7.jpg', input: 6 },
        { url: 'img/FriendsPlus/Page7/E3/8.jpg', input: 7 },
        { url: 'img/FriendsPlus/Page7/E3/9.jpg', input: 8 },
        { url: 'img/FriendsPlus/Page7/E3/10.jpg', input: 9 },
        { url: 'img/FriendsPlus/Page7/E3/11.jpg', input: 10 },
      ],

    ],
    questions: [
      {
        title: 'The dictionaries are # the shelf',
        answer: ['table']
      },
    ]
  },
}

export default json;